export function navigateTo(path: string, locale: string) {
  if (path.startsWith("https")) {
    window.location.href = path;
  } else {
    location.replace(`/${locale}/${path}`);
  }
}
